import { Text, TextLink } from "@origin-digital/ods-core";
import React from "react";
import { LocationType } from "../../model/ILocationValidation";

export interface IAddressSelectorHelperTextProps {
  errorMessage?: string;
  hasNaturalGas?: boolean;
  originAddressId?: string;
  locationType?: LocationType;
  helpText?: string;
}

export const AddressSelectorHelperText = ({
  errorMessage,
  hasNaturalGas,
  originAddressId,
  locationType,
  helpText,
}: IAddressSelectorHelperTextProps) => {
  if (errorMessage) {
    return <>{errorMessage}</>;
  }

  if (hasNaturalGas) {
    return (
      <Text data-id="address-has-natural-gas">
        It looks like there’s natural gas at your address. Sign up for a{" "}
        <TextLink
          data-id="compare-natural-gas"
          href={`/electricity-gas/plans.html?originAddressId=${originAddressId}`}
        >
          natural gas energy plan
        </TextLink>{" "}
        instead.
      </Text>
    );
  }

  if (locationType) {
    switch (locationType) {
      case LocationType.INSITU:
        return (
          <Text>
            It looks like your address has refill by hose. You can see available
            offers for refill below.
          </Text>
        );
      case LocationType.METERED:
        return (
          <Text>
            It looks like there is Metered LPG at your address. For help setting
            up your account, call us on
            <TextLink href="tel:13 35 74"> 13 35 74</TextLink>.
          </Text>
        );
      default:
      // noop
    }
  }

  if (helpText) {
    return <>{helpText}</>;
  }

  return null;
};
